import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction as createTypedAction} from 'web-app/util/redux/typed-action-helpers';

import {type ProgressUpdatePayload} from './types';
import type * as Constants from './constants';

const domain = 'REVENUE_REPORT';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH_TABLE_DATA`,
    (
        targetId: string,
        targetType: Constants.REVENUE_TARGET_TYPES,
        year: string,
        refresh: boolean,
        filter: Constants.REVENUE_FILTER | null,
        firstMonth: string,
        numberOfMonths: string,
    ) => ({
        targetId,
        targetType,
        year,
        refresh,
        filter,
        firstMonth,
        numberOfMonths,
    }),
    response => ({response}),
);

export const {action: fetchProgress} = createAction(
    `${domain}/HANDLE_REVENUE_REPORT_PROGRESS_UPDATE`,
    (
        targetId: string,
        targetType: Constants.REVENUE_TARGET_TYPES,
        year: string,
        refresh: boolean,
        filter: Constants.REVENUE_FILTER,
        firstMonth: string,
        numberOfMonths: string,
    ) => ({
        targetId,
        targetType,
        year,
        refresh,
        filter,
        firstMonth,
        numberOfMonths,
    }),
    response => response,
);

export const progressUpdate = createTypedAction(
    `${domain}/REVENUE_REPORT_PROGRESS_UPDATE`,
    ({result, originalPayload}: ProgressUpdatePayload) => ({
        result,
        originalPayload,
    }),
);
export const {action: stopPolling} = createTypedAction(`${domain}/REVENUE_REPORT_STOP_POLLING`, () => ({}));
export const {action: refreshUpdateStarted} = createTypedAction(`${domain}/REVENUE_REPORT_REFRESH_STARTED`, () => ({}));
export const {action: refreshUpdateStopped} = createTypedAction(`${domain}/REVENUE_REPORT_REFRESH_STOPPED`, () => ({}));
